import { cloneDeep, get, isArray, isEmpty } from 'lodash'
import { change, getFormValues } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import { fireToastWarning } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { PriceFormActions } from '../../reducers/price/actionNames'

function* calculatePrice(action) {
  const values = yield Effects.select(getFormValues(action.form))

  const fields = ['adult', 'price', 'additional', 'kid']
  const allowedKeys = ['short_stay', 'long_stay', 'weekend', 'standard']
  let wasChangedToZeroOrBelow = false

  const transform = obj => ([key, value]) => {
    if (!allowedKeys.includes(key)) {
      return
    }
    if (Number(value)) {
      if (Number(values.converterType) === 1 && Number(value)) {
        const result = Number(value) + Number(values.converterAmount)
        if (result <= 0) {
          wasChangedToZeroOrBelow = true
        }
        obj[key] = result > 0 ? String(result) : 0
      } else {
        const converterAmount = Math.max(Number(values.converterAmount), -100)
        const result = Number(value) + (Number(value) * converterAmount) / 100
        if (result <= 0) {
          wasChangedToZeroOrBelow = true
        }
        obj[key] = String(result)
      }
    }
  }

  yield Effects.all(
    fields.map(field => {
      const rawObj = get(values, field, undefined)
      let obj
      if (!isEmpty(rawObj) && !isArray(rawObj)) {
        obj = { ...cloneDeep(rawObj) }
        Object.entries(obj).forEach(transform(obj))
      } else if (isArray(rawObj)) {
        obj = [...cloneDeep(rawObj)]
        obj.forEach(o => {
          if (!isEmpty(o)) {
            Object.entries(o).forEach(transform(o))
          }
        })
      }
      return Effects.put(change(action.form, field, obj))
    }),
  )

  if (wasChangedToZeroOrBelow) {
    yield put(fireToastWarning(i18n.t('BBO_1494_price_zero_or_below')))
  }
}

export default function* () {
  yield Effects.takeEvery(PriceFormActions.CalculatePrices, calculatePrice)
}
